import { Modal } from '@carbon/react';
import { defineMessages, useIntl } from 'react-intl';
import { useState } from 'react';
import { TrashCan } from '@carbon/icons-react';

import sharedMessages from 'Components/utils/sharedMessages';
import CommonButton from 'Components/Common/CommonButton/CommonButton';
import { useDeletePointMutation } from 'api/pointsEndpoints';
import useGetCurrentEntityId from 'hooks/useGetCurrentEntityId';

type Props = {
    id: string;
    onSuccess?: () => void;
}

const PointOperationRemoval = ({
    id,
    onSuccess,
}: Props) => {
    const intl = useIntl();
    const [open, setOpen] = useState(false);
    const [deletePointOperation, { isLoading }] = useDeletePointMutation();
    const currentEntityId = useGetCurrentEntityId();

    const onFinalSubmit = async () => {
        if (!currentEntityId) {
            return;
        }

        try {
            await deletePointOperation({
                id,
                entityId: currentEntityId,
            }).unwrap();
            onSuccess?.();
            onClose();
        } catch (e: any) {
            console.log('error'); // TO_DO
        }
    };

    const onOpen = () => { setOpen(true); };
    const onClose = () => { setOpen(false); };

    return (
        <>
            <CommonButton
                align="bottom"
                label={intl.formatMessage(sharedMessages.remove)}
                kind="ghost"
                iconSize={21}
                icon={<TrashCan />}
                onClick={onOpen}
            />
            <Modal
                preventCloseOnClickOutside
                open={open}
                onRequestClose={onClose}
                onRequestSubmit={onFinalSubmit}
                primaryButtonDisabled={isLoading}
                danger
                modalHeading={intl.formatMessage(messages.heading)}
                modalLabel={intl.formatMessage(sharedMessages.irreversibleAction)}
                primaryButtonText={intl.formatMessage(sharedMessages.submit)}
                closeButtonLabel={intl.formatMessage(sharedMessages.cancel)}
                secondaryButtonText={intl.formatMessage(sharedMessages.back)}
            />
        </>
    );
};

const messages = defineMessages({
    heading: {
        id: 'src.Screens.Dashboard.Team.Components.TeamCellHandler.TeamInteractions.Interactions.Details.Components.PointsHistoryTable.PointOperationRemoval.PointOperationRemoval.heading',
        defaultMessage: 'Czy na pewno chcesz usunąć tę operację z punktami?',
    },
});

export default PointOperationRemoval;
